import { render, staticRenderFns } from "./ImagesPreview.vue?vue&type=template&id=6bf9ed6c&scoped=true&"
import script from "./ImagesPreview.vue?vue&type=script&lang=js&"
export * from "./ImagesPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImagesPreview.vue?vue&type=style&index=0&id=6bf9ed6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf9ed6c",
  null
  
)

export default component.exports